import { getCookie, delCookie } from './util_03_cookie';
/* eslint-disable */

/**
 * @author fredwu
 * @date 2013-12-29
 * @description 登录组件
 * @param {Object} opt
    {
       needMask: true,   //是否需要蒙板, 默认为"true"
       mode: 'xui',      //支持降域（ui）和不降域(xui)两种登录模式，默认为"xui"不降域
       closeIcon: false, //是否需要右上角的关闭icon，默认为"false"不需要
       target: 'self',   //指定登录后的重定向的页面窗口（top|parent|self）,默认为“self”
       appid: 715030901, //业务向ptlogin2申请的ID,
       succUrl: 'url',  //成功跳转的url,需要业务encodeURIComponent，降域方式默认为“http：//ui.ptlogin2.qq.com/login_proxy.html”，
                        //非降域方式默认为："http://id.qq.com/login_proxy.html"
       proxyUrl: 'url'  //代理页面URL，用于在不降域的情况下页面与父页面在IE6/7下进行通信, ,需要业务encodeURIComponent，
                        //默认为“http://id.qq.com/login_proxy.html”，切记将proxy.html文件拷到站点的根目录下
   }
 * @example Login.show({succ: function () {console.log('login success')}})
 */

/* jshint ignore:start */
var _global = typeof window !== 'undefined' && window || {};

var wxCssUri = [typeof window !== 'undefined' ? location.protocol : 'https:', '//gy.fudao.qq.com/loginWx.css'].join(''); // 各种状态变量

var status = {
  uin: 0,
  curUin: 0,
  ctn: false
};

function extend(dst, src) {
  if (arguments.length < 2) {
    return extend(this, dst);
  }

  dst = dst || {};

  for (var prop in src) {
    dst[prop] = src[prop];
  }

  return dst;
}

function uin() {
  // var u = getCookie("uin") || getCookie("uid_uin");
  var puin = getCookie('p_uin');
  var uin = getCookie('uin');
  var uidUin = getCookie('uid_uin');
  var u;

  if (getCookie('uid_type') === '2') {
    u = uidUin || uin;
    return u;
  }

  u = puin || uin;

  if (u) {
    return u.substring(1, u.length);
  }

  return uidUin || null;
}

function skey() {
  return getCookie('skey');
}

function addEvent(obj, type, fn) {
  if (obj.attachEvent) {
    obj.attachEvent("on".concat(type), fn);
  } else {
    obj.addEventListener(type, fn, false);
  }
}

function removeEvent(obj, type, fn) {
  if (obj.detachEvent) {
    obj.detachEvent("on".concat(type), fn);
  } else {
    obj.removeEventListener(type, fn, false);
  }
}

function str2JSON(str) {
  var __pt_json = eval("(".concat(str, ")"));

  return __pt_json;
}

function isWeixinUser() {
  var uidType = getCookie('uid_type'); // uid_type类型详见tapd：http://tapd.oa.com/QQConnectSys/wikis/view/uid_account_type_x

  return uidType === '2';
} // ------------  通用方法代码块 end ---------------------------------------------
// ------------  微信长轮询 start ---------------------------------------------


var longpoll = {
  timeout: null,
  timespace: 2000,
  handle: function handle() {
    var self = this;

    if (isWeixinUser()) {
      clearTimeout(self.timeout);
      execTasks(__cbSucc); // if login just hidden Login

      hide();
      onStatusChanged && onStatusChanged();
    }
  },
  init: function init() {
    var self = this;
    clearTimeout(self.timeout);
    self.timeout = setInterval(function () {
      self.handle();
    }, self.timespace);
  },
  destroy: function destroy() {
    clearTimeout(self.timeout);
  }
}; // ------------  微信长轮询 end ---------------------------------------------
// 各种配置项

var config = {
  needMask: true,
  mode: 'xui',
  closeIcon: false,
  target: 'self',
  appid: 715030901,
  daid: 444
};
var hostDomain = typeof window !== 'undefined' && (location.hostname.match(/(\.\w+){2}$/) || [".".concat(location.hostname)])[0];
var fudaoDomain = typeof window !== 'undefined' && location.hostname;
var userConfig = {};
var ptConfig = {};
var __cbSucc = [],
    __cbClose = [];
var onStatusChanged;
var undefined;
var outer,
    loginFrame,
    mask,
    isShowFrame = false,
    clickIndex = 0; // 添加变量使用新的手机号注册逻辑进行登录/注册，@see pc/signin_phone.html模块
// 用于保存host window的onmessage监听

var windowOnMessageListener = null;

function showMask(opt) {
  mask = document.createElement('div');
  mask.className = 'ptlogin-mask';
  mask.style.cssText = 'position:fixed;_position:absolute;width:100%;height:100%;padding:0;' + 'margin:0;left:0;top:0; z-index:2000;filter:alpha(opacity=80);opacity:0.8;background-color:gray;';
  document.body.appendChild(mask);
} // 微信登录处理


function weixinHandle() {
  var protocal = location.protocol;
  var url = "".concat(protocal, "//gy.fudao.qq.com/pc/weixinCallBack.html");
  var src = "".concat('//open.weixin.qq.com/connect/qrconnect?appid=wxa06e26fdaf1bf677' + '&redirect_uri=').concat(encodeURIComponent("".concat(protocal, "//gy.fudao.qq.com/cgi-bin/uidaccount/k12/login?ttype=4&account_type=2") + "&normal_login=1&appid=wxa06e26fdaf1bf677&buz_id=122051800&redirect_uri=".concat(encodeURIComponent(url))), "&response_type=code&scope=snsapi_login#wechat_redirect");
  var feature = 'location=yes,left=755,top=225,width=400,height=570,resizable=yes';
  var newWindow = window.open(src, 'wechat', feature);
  newWindow.focus();
  longpoll.init();
}

function makeLoginUrl(options) {
  var param = {
    target: ptConfig.target,
    appid: ptConfig.appid,
    hide_close_icon: 1 - !!ptConfig.closeIcon,
    s_url: ptConfig.succUrl
  };
  var strBuffer = [];
  var jumpUrl = "/login_proxy.html?".concat(options.domain ? "#domain=".concat(options.domain) : '');

  if (ptConfig.daid) {
    param.daid = ptConfig.daid;
  }

  if (ptConfig.mode === 'xui') {
    strBuffer.push("//xui.ptlogin2".concat(hostDomain, "/cgi-bin/xlogin?"));
    var pureUrl = location.href.split(/#|\?/)[0],
        startFileName = pureUrl.indexOf('/', pureUrl.indexOf('//') + 2);
    var proxyUrl = encodeURIComponent((startFileName !== -1 ? pureUrl.substring(0, startFileName) : pureUrl) + jumpUrl);
    param.proxy_url = ptConfig.proxyUrl || proxyUrl;
    param.s_url = ptConfig.succUrl || proxyUrl;
  } else {
    param.s_url = ptConfig.succUrl || encodeURIComponent("//ui.ptlogin2.".concat(hostDomain).concat(jumpUrl));
    strBuffer.push("//ui.ptlogin2".concat(hostDomain, "/cgi-bin/login?"));
  }

  ptConfig.style && (param.style = ptConfig.style);
  param.low_login_enable = 1;

  for (var key in param) {
    strBuffer.push("".concat(key, "=").concat(param[key]));
  }

  return strBuffer.join('&');
}

function generateUrlForWx() {
  var url = location.href;
  var protocal = location.protocol;
  var redirect_uri = [protocal, '//gy.fudao.qq.com/cgi-bin/uidaccount/k12/login?normal_login=1&ttype=4&account_type=2', '&appid=wxa06e26fdaf1bf677&buz_id=122051800&redirect_uri=', encodeURIComponent(url)].join('');
  return ['//open.weixin.qq.com/connect/qrconnect?appid=wxa06e26fdaf1bf677' + '&redirect_uri=', encodeURIComponent(redirect_uri), '&href=', encodeURIComponent(wxCssUri), '&response_type=code&scope=snsapi_login#wechat_redirect'].join('');
} // ------------  h5 message api封装 start ---------------------------------------------


function onmessage(event) {
  var msg = event || _global.event; // 此处兼容IE8

  if ((event.origin || '').indexOf('ptlogin2') === -1) {
    return;
  }

  var data;

  try {
    if (typeof JSON !== 'undefined') {
      data = JSON.parse(msg.data);
    } else {
      data = str2JSON(msg.data);
    }
  } catch (e) {
    if (window.BJ_REPORT) {
      window.BJ_REPORT.info("pcLogin onmessage parse json err: ".concat(msg.data));
    }
  }

  switch (data.action) {
    case 'close':
      _global.ptlogin2_onClose();

      break;

    case 'resize':
      _global.ptlogin2_onResize(data.width, data.height);

      break;
  }
}

function bindMessageAPI() {
  if (typeof _global.postMessage !== 'undefined') {
    addEvent(_global, 'message', onmessage);
  }
}

function unbindMessageAPI() {
  if (typeof _global.postMessage !== 'undefined') {
    removeEvent(_global, 'message', onmessage);
  }
} // ----------- h5 message api封装 end ---------------------------------------------
// ----------- 统一登录回调方法 start ---------------------------------------------


_global.ptlogin2_onClose = function () {
  execTasks(__cbClose);
  hide(); // 清除微信轮询

  clearTimeout(longpoll.timeout);
};

_global.ptlogin2_onResize = function (width, height) {
  // console.log('ptlogin2_onResize', width, height);
  // 获得浮动Div对象
  if (outer) {
    outer.wrapHeight = height + outer.footerHeight;
    outer.marginTop = -(outer.wrapHeight / 2); // 重新设置大小注意，一定要加px，否则firefox下有问题

    outer.style.width = "".concat(width, "px");
    outer.style.height = "".concat(outer.wrapHeight, "px");
    outer.style.marginLeft = "".concat(-width / 2, "px");
    outer.style.marginTop = "".concat(outer.marginTop, "px");
    outer.style.visibility = 'visible';
    var login_weixin = document.getElementById('js-login-weixin');
    login_weixin && (login_weixin.onclick = weixinHandle);
  }
};

_global.ptlogin2_login_ok = function (obj) {
  // 如果是微信用户切到qq用户 - 飞机票场景
  if (!status.uin) {
    delCookie('uid_a2', hostDomain);
    delCookie('uid_type', hostDomain);
    delCookie('uid_uin', hostDomain);
  }

  execTasks(__cbSucc);
  onStatusChanged && onStatusChanged();
  hide();
}; // 执行回调任务


function execTasks(tasks) {
  for (var i = 0, len = (tasks || []).length; i < len; i++) {
    try {
      tasks[i]();
    } catch (e) {}
  }
}

function setUin(uin) {
  status.uin = uin;
}

function isUinChanged() {
  return status.uin != uin();
} // ----------- 统一登录回调方法 end ---------------------------------------------
// ----------- 外部接口 start ---------------------------------------------

/**
 * @description 显示登录面板
 */


function setOpt(opt) {
  if (!opt) {
    return;
  }

  opt.succ && __cbSucc.push(opt.succ);
  opt.close && __cbClose.push(opt.close);

  for (var key in opt) {
    if (typeof opt[key] !== 'undefined') {
      userConfig[key] = opt[key];
    }
  }
}
/**
 * @description 初始化登录面板
 */


function init(opt) {
  opt && opt.onStatusChanged && (onStatusChanged = opt.onStatusChanged);

  if (outer) {
    opt && setOpt({
      succ: opt.succ,
      close: opt.close
    });
    return;
  }

  setOpt(opt);
}
/**
 * @description 显示登录面板
 */


function show(opt) {
  opt = opt || {};

  if (outer) {
    opt && setOpt({
      succ: opt.succ,
      close: opt.close
    });
    return;
  }

  setOpt(opt);

  if (!isShowFrame) {
    isShowFrame = true;
    extend(extend(ptConfig, config), userConfig);
    ptConfig.needMask && showMask(ptConfig);
    status.ctn = opt.ctn; // showFrame(makeLoginUrl({ domain: opt.domain || '' }), opt.ctn,  opt.loginMethod);
    // ptConfig.mode === 'xui' && bindMessageAPI();
    // bindEvent();

    if (!loginFrame) {
      loginFrame = document.createElement('div');
      loginFrame.className = 'ptlogin-wrap';
      document.body.appendChild(loginFrame);
    } // 逻辑转向//gy.fudao.qq.com/pc/signin_phone.html?ctn={ctn}&loginMethod={loginMethod}


    var redirectUrl = "//gy.fudao.qq.com/pc/signin_phone.html?ctn=".concat(opt.ctn) + "&loginMethod=".concat(opt.loginMethod, "&tabsShow=").concat(opt.loginMethod) + "&caseType=".concat(opt.caseType) + "&parent_href=".concat(encodeURIComponent(window.location.href)) + "#".concat(opt.hash || '/');
    var iframe = document.createElement('iframe');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '100%');
    iframe.setAttribute('src', redirectUrl);
    iframe.setAttribute('style', 'width: 560px;height: 460px;border: none;border-radius: 4px;overflow: hidden;');
    loginFrame.appendChild(iframe); // 绑定事件

    if (ptConfig.mode === 'xui') {
      // FILO
      var executeTaskReverse = function executeTaskReverse(tasks) {
        var task = tasks.pop();

        while (task) {
          task();
          task = tasks.pop();
        }
      };

      ;

      windowOnMessageListener = function windowOnMessageListener(event) {
        event = event || _global.event;
        var origin = event.origin || '';
        if (origin.indexOf('fudao') < 0) return;

        switch (event.data) {
          case 'close':
            executeTaskReverse(__cbClose);
            hide();
            break;

          case 'done_and_close':
            executeTaskReverse(__cbSucc);
            hide();
            break;

          default:
            if (window.BJ_REPORT) {
              window.BJ_REPORT.info("pcLogin onmessage parse json err: ".concat(event.data));
            }

            break;
        }
      };

      _global.addEventListener('message', windowOnMessageListener);
    }
  }
}
/**
 * @description 隐藏登录面板
 */


function hide() {
  isShowFrame = false;

  if (loginFrame) {
    document.body.removeChild(loginFrame);
    loginFrame = undefined;
  }

  if (mask) {
    document.body.removeChild(mask);
    mask = undefined;
  }

  __cbSucc = [];
  __cbClose = [];
  ptConfig.mode === 'xui' && unbindMessageAPI(); // unbind the onmessage

  if (windowOnMessageListener) _global.removeEventListener('messsage', windowOnMessageListener);
  windowOnMessageListener = null;
}

function loadScript(url, callback) {
  callback = callback || function () {};

  var script = document.createElement('script');
  script.type = 'text/javascript';

  if (script.readyState) {
    // IE
    script.onreadystatechange = function () {
      if (script.readyState == 'loaded' || script.readyState == 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    // Others: Firefox, Safari, Chrome, and Opera
    script.onload = function () {
      callback();
    };
  }

  script.src = url;
  document.body.appendChild(script);
}
/**
 * @description 退出登录(删除登录态)
 */


function logout() {
  // //qq
  // delCookie("uin", hostDomain);
  // delCookie("skey", hostDomain);
  // delCookie("lskey", hostDomain);
  // //weixin
  // delCookie("uid_a2", hostDomain);
  // delCookie("uid_type", hostDomain);
  // delCookie("uid_uin", hostDomain);
  // onStatusChanged && onStatusChanged();
  // location.reload();

  /* delCookie('p_uin', hostDomain);
    delCookie('p_skey', hostDomain);
    delCookie("lskey", hostDomain); */
  loadScript('https://ui.ptlogin2.qq.com/js/ptloginout.js', function () {
    window.pt_logout.logout(function () {
      // weixin
      delCookie('uid_a2', fudaoDomain);
      delCookie('uid_type', fudaoDomain);
      delCookie('uid_uin', fudaoDomain);
      onStatusChanged && onStatusChanged();
      location.reload();
    });
  });
}

function delAllCookie() {
  loadScript('https://ui.ptlogin2.qq.com/js/ptloginout.js', function () {
    window.pt_logout.logout(function () {
      delCookie('uid_a2', hostDomain);
      delCookie('uid_type', hostDomain);
      delCookie('uid_uin', hostDomain);
      delCookie('openid', hostDomain);
      delCookie('uid_appid', hostDomain);
      onStatusChanged && onStatusChanged();
    });
  });
}
/**
 * 检查是否有登录态
 * @return {Boolean} true：有，false：无
 */


function isLogin() {
  return !!getCookie('p_uin') && !!getCookie('p_skey') || !!getCookie('uin') && !!getCookie('skey') || !!getCookie('uid_uin') && !!getCookie('uid_a2');
} // ----------- 外部接口 end ---------------------------------------------


var pcLogin = {
  init: init,
  show: show,
  hide: hide,
  logout: logout,
  isLogin: isLogin,
  uin: uin,
  skey: skey,
  setUin: setUin,
  isUinChanged: isUinChanged,
  isWeixinUser: isWeixinUser,
  delAllCookie: delAllCookie,
  makeLoginUrl: makeLoginUrl,
  generateUrlForWx: generateUrlForWx
};
export { pcLogin };
/* jshint ignore:end */